"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkScheduleEntryType = exports.isScheduleEntryType = void 0;
const __1 = require("..");
const ScheduleEntryTypeCategory_1 = require("./ScheduleEntryTypeCategory");
const ScheduleEntryTypeIcon_1 = require("./ScheduleEntryTypeIcon");
function isScheduleEntryType(object) {
    return checkScheduleEntryType(object).fulfilled;
}
exports.isScheduleEntryType = isScheduleEntryType;
function checkScheduleEntryType(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, __1.check)(object, (0, __1.hasString)("id"), (0, __1.hasChoice)("category", Object.values(ScheduleEntryTypeCategory_1.ScheduleEntryTypeCategory)), (0, __1.hasString)("name"), (0, __1.hasChoice)("icon", Object.values(ScheduleEntryTypeIcon_1.ScheduleEntryTypeIcon)), (0, __1.hasString)("colorTag"), (0, __1.hasBoolean)("isDefault").optional(), (0, __1.hasBoolean)("isDeleted").optional()).withOptions(options).explain();
}
exports.checkScheduleEntryType = checkScheduleEntryType;
//# sourceMappingURL=ScheduleEntryType.js.map